var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReminderSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4B2B5A",
    fillRule: "evenodd",
    d: "M7.3 4.4c.2.3 0 .8-.3 1C5.3 6.4 4 8 3.4 10c0 .3-.3.5-.7.5h-.2a.8.8 0 0 1-.5-1A9.9 9.9 0 0 1 6.3 4c.3-.2.8 0 1 .3Zm9.4-.3c2 1.3 3.5 3.2 4.3 5.4a.8.8 0 0 1-.7 1 .7.7 0 0 1-.7-.5 8.5 8.5 0 0 0-3.7-4.6.7.7 0 0 1-.2-1c.2-.4.7-.5 1-.3Zm-3 7.7h-1.5v-2c0-.5-.3-.8-.7-.8-.4 0-.8.3-.8.7v2.9c0 .4.4.7.8.7h2.1c.4 0 .8-.3.8-.7 0-.4-.3-.8-.8-.8Zm-9 .8a6.7 6.7 0 1 1 11.6 4.6l1.7 2.2c.2.3.2.8-.1 1-.4.3-.8.2-1-.1l-1.7-2.1a6.7 6.7 0 0 1-7.4 0l-1.6 2c-.2.3-.4.4-.6.4-.2 0-.4 0-.5-.2a.8.8 0 0 1-.1-1l1.6-2.2a6.8 6.8 0 0 1-1.8-4.6Zm6.8-5.3a5.3 5.3 0 0 0-5.3 5.3 5.3 5.3 0 0 0 10.5 0c0-3-2.3-5.3-5.2-5.3Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminderSvg);
export default __webpack_public_path__ + "static/media/reminderSvg.ea41401d209fbc15e0ac892855ffba52.svg";
export { ForwardRef as ReactComponent };